import TableWithTitle from "@/components/TableWithTitle.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange, transformGoogleSheetFromCSV, getColorForDecile } from "@/utils/transformers";
import { SELECTOR, LTV_PERIOD_FIELD, LTV_NEW_CUSTOMERS, LTV_CAC, LTV_RETENTION_RATE_MONTHLY, LTV_FIRST_ORDER, LTV_OFFSET_0, LTV_OFFSET_1, LTV_OFFSET_2, LTV_OFFSET_3, LTV_OFFSET_4, LTV_OFFSET_5, LTV_OFFSET_6, LTV_OFFSET_7, LTV_OFFSET_8, LTV_OFFSET_9, LTV_OFFSET_10, LTV_OFFSET_11, LTV_OFFSET_12, LTV_OFFSET_13, LTV_OFFSET_14, LTV_OFFSET_15, LTV_OFFSET_16, LTV_OFFSET_17, LTV_OFFSET_18, LTV_OFFSET_19, LTV_OFFSET_20, LTV_OFFSET_21, LTV_OFFSET_22, LTV_OFFSET_23, LTV_OFFSET_24 } from "@/utils/table_fields";
import AppIcon from "@/components/AppIcon.vue";
import { mapState } from "vuex";
import { HugValue, DateValue, RateChangeValue, CurrencyValue, NumberValue, BoxedValue, BarWithValue, PercentageValue, DottedValue, OverlapBarValue, EvolutionArrow, SegmentedBar, ImageElement, HashedNumberValue, DottedPositionBar, DashedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement, ValueElement } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { DEFAULT_DATE_FORMATS, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, PERIOD_COLUMN_TITLES, COLORS, APP_LTV_DROPDOWN_ELEMENTS, CUSTOMER_INSIGHTS_LTV_COLORS } from "@/utils/constants";
import FlexRow from "@/components/FlexRow.vue";
import moment from "moment";
import { capitalize } from "vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
export default {
  name: "LTVPeriodTable",
  components: {
    TableWithTitle,
    WrapWithPopover,
    AppIcon,
    HugValue,
    DateValue,
    RateChangeValue,
    CurrencyValue,
    NumberValue,
    BoxedValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TextValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    HashedNumberValue,
    DottedPositionBar,
    DashedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement,
    ValueElement
  },
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  props: {
    loading: {
      typ: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      CUSTOMER_INSIGHTS_LTV_COLORS,
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      PERIOD_COLUMN_TITLES,
      COLORS,
      fixed_fields: [SELECTOR, LTV_PERIOD_FIELD, LTV_NEW_CUSTOMERS, LTV_FIRST_ORDER],
      offsetFields: [LTV_OFFSET_0, LTV_OFFSET_1, LTV_OFFSET_2, LTV_OFFSET_3, LTV_OFFSET_4, LTV_OFFSET_5, LTV_OFFSET_6, LTV_OFFSET_7, LTV_OFFSET_8, LTV_OFFSET_9, LTV_OFFSET_10, LTV_OFFSET_11, LTV_OFFSET_12, LTV_OFFSET_13, LTV_OFFSET_14, LTV_OFFSET_15, LTV_OFFSET_16, LTV_OFFSET_17, LTV_OFFSET_18, LTV_OFFSET_19, LTV_OFFSET_20, LTV_OFFSET_21, LTV_OFFSET_22, LTV_OFFSET_23, LTV_OFFSET_24],
      currency_ltv_options: [APP_LTV_DROPDOWN_ELEMENTS.LTV.value, APP_LTV_DROPDOWN_ELEMENTS.REPEAT_LTV.value, APP_LTV_DROPDOWN_ELEMENTS.REPEAT_AOV.value],
      percentage_ltv_options: [APP_LTV_DROPDOWN_ELEMENTS.REPURCHASE_RATE.value],
      number_ltv_options: [APP_LTV_DROPDOWN_ELEMENTS.REPURCHASE_FREQUENCY.value],
      evolCategory: {
        prev_period: "customers_in_cohort_evol_pp",
        same_period_ly: "customers_in_cohort_evol_yoy"
      },
      csvSources: period => ({
        [PERIOD_COLUMN_TITLES[period]]: `period_agg`,
        [ACTIVE_CUSTOMER_12M.label]: ACTIVE_CUSTOMER_12M.key,
        [`${ACTIVE_CUSTOMER_12M.label} Previous Period Evolution`]: `${ACTIVE_CUSTOMER_12M.key}_evol_vs_previous_period_pc`,
        [`${ACTIVE_CUSTOMER_12M.label} Same Period Last Year Evolution`]: `${ACTIVE_CUSTOMER_12M.key}_evol_vs_last_year_pc`,
        [NEW_CUSTOMERS_MONTH.label]: NEW_CUSTOMERS_MONTH.key,
        [`${NEW_CUSTOMERS_MONTH.label} Previous Period Evolution`]: `${NEW_CUSTOMERS_MONTH.key}_evol_vs_previous_period_pc`,
        [`${NEW_CUSTOMERS_MONTH.label} Same Period Last Year Evolution`]: `${NEW_CUSTOMERS_MONTH.key}_evol_vs_last_year_pc`,
        [PCT_NEW_CUSTOMERS.label]: PCT_NEW_CUSTOMERS.key,
        [`${PCT_NEW_CUSTOMERS.label} Previous Period Evolution`]: `${PCT_NEW_CUSTOMERS.key}_evol_vs_previous_period_pc`,
        [`${PCT_NEW_CUSTOMERS.label} Same Period Last Year Evolution`]: `${PCT_NEW_CUSTOMERS.key}_evol_vs_last_year_pc`,
        [CHURNED_CUSTOMERS_12M_MONTH.label]: CHURNED_CUSTOMERS_12M_MONTH.key,
        [PCT_CHURNED_CUSTOMERS_12M.label]: PCT_CHURNED_CUSTOMERS_12M.key,
        [REACTIVATED_CUSTOMERS_MONTH.label]: REACTIVATED_CUSTOMERS_MONTH.key,
        [AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M.label]: AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M.key,
        [AVG_AOV_12M.label]: AVG_AOV_12M.key,
        [AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M.label]: AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M.key,
        [MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M.label]: MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M.key,
        [PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES.label]: PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES.key,
        [PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH.label]: PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH.key
      })
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.customer_insights.periodTable,
      tab: state => state.customer_insights.currentTabValue,
      period: state => state.customer_insights.period,
      currentPeriod: state => state.customer_insights.currentPeriod,
      periodCategory: state => state.customer_insights.periodCategory,
      ltv: state => state.customer_insights.ltv,
      ltvOffset: state => state.customer_insights.ltvOffset
    }),
    items() {
      if (this.periodTable[this.tab].items.length == 0) {
        window.$bus.trigger("showDanger", {
          visible: true,
          message: "No cohort data available yet",
          delay: 6000,
          isHtml: true
        });
      }
      let parsedItems = this.periodTable[this.tab]?.items.map(row => ({
        ...row
      }));
      parsedItems?.forEach(row => {
        if (!row.kpis) return row;
        row.kpis = JSON.parse(row.kpis);
      });
      const data = parsedItems?.map(row => {
        if (!row.kpis) return row;
        try {
          row.kpis = (row.kpis.kpis || []).reduce((acc, item) => {
            acc[item.kpi_name] = item.months;
            return acc;
          }, {});
        } catch {
          console.warn("Invalid kpis JSON");
        }
        return row;
      });
      return data;
    },
    average() {
      if (this.periodTable[this.tab].items.length == 0) {
        return this.defaultData;
      }
      let keys = Object.keys(this.items?.[0]);
      let average = keys?.reduce((acc, key) => {
        if (key === "kpis") return acc;
        const values = this.items?.map(item => item[key]).filter(v => typeof v === "number");
        if (!values.length) return acc;
        const avg = values.reduce((sum, v) => sum + v, 0) / values.length;
        acc[key] = avg;
        return acc;
      }, {});
      const kpiKeys = Object.keys(this.items?.[0].kpis);
      const result = {};
      kpiKeys?.forEach(kpi => {
        result[kpi] = {};
        const months = Object.keys(this.items?.[0].kpis[kpi]);
        months.forEach(month => {
          const values = this.items?.map(item => item.kpis?.[kpi]?.[month]).filter(v => typeof v === "number");
          if (!values.length) {
            result[kpi][month] = null;
            return;
          }
          result[kpi][month] = values.reduce((a, b) => a + b, 0) / values.length;
        });
      });
      average["kpis"] = result;
      console.log(average);
      return average;
    },
    fields() {
      const selectedOffsetFields = this.offsetFields.filter(field => this.ltvOffset.includes(field.key));
      return [...this.fixed_fields, ...selectedOffsetFields];
    },
    maxCharCount() {
      return this.periodTable[this.tab]?.maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab]?.minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch("customerInsightsIncrementPeriodPage");
        this.$emit("refresh");
      }
    },
    customerNumberFormat() {
      return num => {
        if (num >= 1_000) return (num / 1000).toFixed(1) + "K";
        return num;
      };
    },
    computedMinMax() {
      let valueArray = this.items?.flatMap(item => this.ltvOffset.map(offset => item.kpis?.[this.ltv]?.["m" + offset.split("_")[2]]));
      console.log("valueArray", valueArray);
      const numbers = valueArray.filter(v => typeof v === "number");
      return {
        min: Math.min(...numbers),
        max: Math.max(...numbers)
      };
    },
    defaultData() {
      const kpis_keys = ["active_customers", "fist_purchase_aov_margin_cum", "fist_purchase_aov_revenue_excl_vat_cum", "fist_purchase_ltv_margin", "fist_purchase_ltv_revenue_excl_vat", "ltv_margin", "ltv_revenue_excl_vat", "margin_excl_vat", "orders", "purchase_frequency_cum", "repeat_aov_margin_cum", "repeat_aov_revenue_excl_vat_cum", "repeat_ltv_margin", "repeat_ltv_revenue_excl_vat", "repeat_margin_cum", "repeat_orders_cum", "repeat_revenue_excl_vat_cum", "repurchase_frequency_cum", "repurchase_rate_cum", "revenue_excl_vat"];
      const cohort_keys = this.offsetFields.map(offset => {
        return "m" + offset.key.split("_")[2];
      });
      const default_cohort_value = Object.fromEntries(cohort_keys.map(k => [k, null]));
      const default_kpis_value = Object.fromEntries(kpis_keys.map(k => [k, default_cohort_value]));
      return {
        customers_in_cohort: null,
        customers_in_cohort_prev_period: null,
        customers_in_cohort_prev_year: null,
        customers_in_cohort_evol_pp: null,
        customers_in_cohort_evol_yoy: null,
        kpis: default_kpis_value
      };
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorForDecile,
    prepareItems(items) {
      return items.map(row => {
        if (!row.kpis) return row;
        try {
          const parsed = JSON.parse(row.kpis);
          row.kpis = (parsed.kpis || []).reduce((acc, item) => {
            acc[item.kpi_name] = item.months;
            return acc;
          }, {});
        } catch {
          console.warn("Invalid kpis JSON");
        }
        return row;
      });
    }
  }
};